import { Box, Button, Container, Paper, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Subheader } from 'components';
import AchievementDetails from 'features/achievements/AchievementDetails';
import { useAchievements } from 'hooks';

const AchievementShow = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { isLoading, achievement, findAchievement } = useAchievements({
		id: id
	});

	const handleEditClick = () => navigate(`/achievements/${id}/edit`);

	useEffect(() => {
		if (id) findAchievement(id);
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : achievement.reward?.title}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<AchievementDetails achievement={achievement} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default AchievementShow;
